export type AiChatErrorCode =
  | "network"
  | "offline"
  | "auth"
  | "rate_limit"
  | "server_error"
  | "client_error"
  | "no_body"
  | "stream_error"
  | "reply_error"
  | "unknown";

export class AiChatError extends Error {
  readonly code: AiChatErrorCode;
  readonly statusCode?: number;

  constructor(code: AiChatErrorCode, message: string, statusCode?: number) {
    super(message);
    this.name = "AiChatError";
    this.code = code;
    this.statusCode = statusCode;
  }

  static fromHttpStatus(status: number): AiChatError {
    if (status === 401 || status === 403) {
      return new AiChatError(
        "auth",
        `Authentication failed: ${status}`,
        status
      );
    }
    if (status === 429) {
      return new AiChatError("rate_limit", "Rate limited", status);
    }
    if (status === 408 || status === 504) {
      return new AiChatError("network", `Timeout: ${status}`, status);
    }
    if (status >= 400 && status < 500) {
      return new AiChatError("client_error", `Client error: ${status}`, status);
    }
    if (status >= 500) {
      return new AiChatError("server_error", `Server error: ${status}`, status);
    }
    return new AiChatError("unknown", `Request failed: ${status}`, status);
  }

  static fromNetworkError(cause: Error): AiChatError {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      return new AiChatError("offline", "Device is offline");
    }
    return new AiChatError("network", cause.message);
  }
}
